import React, { useMemo } from 'react';
import { Card, Select } from 'antd';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const { Option } = Select;

// Static demo data specifically for the Portfolio page
const demoSeries = [
  { date: '01-Sep', value: 12000 },
  { date: '03-Sep', value: 26000 },
  { date: '05-Sep', value: 41000 },
  { date: '07-Sep', value: 53000 },
  { date: '09-Sep', value: 47000 },
  { date: '11-Sep', value: 49500 },
  { date: '13-Sep', value: 52000 },
  { date: '15-Sep', value: 50500 },
  { date: '17-Sep', value: 54000 },
  { date: '19-Sep', value: 54000 },
];

const PortfolioAdSpendChart: React.FC = () => {
  const maxValue = useMemo(() => {
    const max = Math.max(...demoSeries.map((i) => i.value));
    return Math.ceil(max / 10000) * 10000 || 30000;
  }, []);

  const yAxisTicks = useMemo(() => {
    const interval = maxValue / 4;
    return [0, interval, interval * 2, interval * 3, maxValue];
  }, [maxValue]);

  return (
    <Card className="shadow-sm border-0 bg-white rounded-lg mb-8" style={{ marginBottom: '2rem' }}>
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-2">
          <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
          <span className="text-orange-500 font-medium">Ad Spend</span>
        </div>
        <Select defaultValue="adSpend" style={{ width: 150 }}>
          <Option value="adSpend">Current Metrics</Option>
          <Option value="impressions">Impressions</Option>
          <Option value="clicks">Clicks</Option>
          <Option value="revenue">Revenue</Option>
        </Select>
      </div>
      <div style={{ height: '300px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={demoSeries} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis
              dataKey="date"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#666' }}
              dy={10}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tickFormatter={(value) => `₹${value / 1000}K`}
              tick={{ fontSize: 12, fill: '#666' }}
              domain={[0, maxValue]}
              ticks={yAxisTicks}
            />
            <Tooltip
              formatter={(value: any) => [`₹${Number(value).toLocaleString()}`, 'Ad Spend']}
              labelStyle={{ color: '#666' }}
            />
            <Line
              type="monotone"
              dataKey="value"
              stroke="#ff6b35"
              strokeWidth={2}
              dot={{ fill: '#ff6b35', stroke: '#fff', strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6, stroke: '#ff6b35', strokeWidth: 2, fill: '#fff' }}
              connectNulls={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default PortfolioAdSpendChart;






